import { Theme, useTheme as useMuiTheme } from '@mui/material/styles'

export const useTheme = () => {
  return useMuiTheme<Theme>()
}
